import React, { useState } from 'react';
import SettingsMain from './SettingsMain';

const SettingsRouter = () => {
  const [activeView, setActiveView] = useState('main');

  const handleSettingsTabSelect = (tabId) => {
    switch (tabId) {
      case 'general':
        setActiveView('general');
        break;
      default:
        setActiveView('main');
    }
  };

  const handleBackToMain = () => {
    setActiveView('main');
  };


  const renderContent = () => {
    switch (activeView) {
      case 'main':
        return (
          <SettingsMain
            activeSettingsTab="main"
            setActiveSettingsTab={handleSettingsTabSelect}
          />
        );

      case 'general':
        return (
          <div className="p-6">
            <div className="max-w-4xl mx-auto">
              <div className="mb-8">
                <button
                  onClick={handleBackToMain}
                  className="text-sm text-gray-600 hover:text-gray-900 mb-4"
                >
                  ← Back to Settings
                </button>
                <h1 className="text-3xl font-bold text-gray-900">General Settings</h1>
                <p className="text-gray-600 mt-2">Application preferences and configuration</p>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Coming Soon</h3>
                <p className="text-gray-600">
                  General settings will be available in a future update. This section will include 
                  application preferences, display options, and other configuration settings.
                </p>
              </div>
            </div>
          </div>
        );

      default:
        return (
          <SettingsMain
            activeSettingsTab="main"
            setActiveSettingsTab={handleSettingsTabSelect}
          />
        );
    }
  };

  return (
    <div className="flex-1 overflow-y-auto bg-gray-50">
      {renderContent()}
    </div>
  );
};

export default SettingsRouter;
